import { ChangeDetectorRef, Component, HostBinding, Input, OnInit, SimpleChanges, Type, ViewChild } from '@angular/core';
import { Banner, BannerOptions, Blog, BlogList, BlogListOptions, Cart, Category, FeaturedProduct, Grid, GridOptions, KwikstoreSection,NewsLetterSignUp,RichTextBlock,Row, Slider, StoreFeatures, Testimonials } from '../../models/sections-model';
import { DynamicRendererComponent, RendererDataInterFace } from '../dynamic-renderer-model';
import { GridRendererComponent } from '../grid-renderer/grid-renderer.component';
import { RenderSectionDirective } from '../../directives/render-section.directive';
import { RowRendererComponent } from '../row-renderer/row-renderer.component';
import { BannerRendererComponent } from '../banner-renderer/banner-renderer.component';
import { BlogListRendererComponent } from '../blog-list-renderer/blog-list-renderer.component';
import { SliderRendererComponent } from '../slider-renderer/slider-renderer.component';
import { NewsletterSignupRendererComponent } from '../newsletter-signup-renderer/newsletter-signup-renderer.component';
import { StoreFeatureRendererComponent } from '../store-feature-renderer/store-feature-renderer.component';
import { RichTextRendererComponent } from '../rich-text-renderer/rich-text-renderer.component';
import { TestimonialRendererComponent } from '../testimonial-renderer/testimonial-renderer.component';
import { CategoryRendererComponent } from '../category-renderer/category-renderer.component';
import { ProductRendererComponent } from '../product-renderer/product-renderer.component';
import { CartRendererComponent } from '../cart-renderer/cart-renderer.component';
import { BlogRendererComponent } from '../blog-renderer/blog-renderer.component';
import { HeroImageRendererComponent } from '../hero-image-renderer/hero-image-renderer.component';

@Component({
  selector: 'ubs-section-renderer',
  templateUrl: './section-renderer.component.html',
  styleUrls: ['./section-renderer.component.scss'],
})
export class SectionRendererComponent implements OnInit {
  @Input() title:string;
  @Input() sectionData:any;
  @Input() rendererType:string;
  @Input() heading:string;
  @Input() categoryId:string;
  @Input() productId:string;
  @Input() gridOptions:GridOptions;
  @Input() bannerOptions:BannerOptions;
  @Input() blogListOptions:BlogListOptions;

  //marginBottom:string;

  section:KwikstoreSection<any>;
  rendererComponent:DynamicRendererComponent;// = new DynamicInputComponent(HeaderInputComponent);
  currentComponent:any;

  
  @ViewChild(RenderSectionDirective, {static: false}) kwRenderSection!: RenderSectionDirective;
  @HostBinding("style.--marginBottom") marginBottom:string;
  @HostBinding('attr.renderer-type') renderer:string;
  
  

  constructor(
    private cdref: ChangeDetectorRef) { }

  ngOnInit(): void {
    /* this.activatedRoute.url
      .pipe(take(1))
      .subscribe(url => console.log('The URL changed to: ' + url)); */
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if(changes['sectionData']){
      console.log({SectionData:this.sectionData,renderType:this.sectionData.rendererType,currentComponent:this.currentComponent});
      if(this.sectionData.marginBottom){
        this.marginBottom = this.sectionData.marginBottom+"px";
        //console.log(this.marginBottom)
      }else{
        this.marginBottom = "16px";
      }
      if(this.sectionData.rendererType != null){
        this.rendererType = this.sectionData.rendererType;
        this.renderer = this.rendererType;
        console.log(this.rendererType)
        switch (this.rendererType) {
          case "grid":
          case "GRID":
          case "RendererType.GRID":
            this.section = new KwikstoreSection<Grid>();
            this.section.heading = this.heading;
            this.section.categoryId = this.categoryId;
            this.section.productId = this.productId;
            this.section.sectionData = this.sectionData;
            this.rendererComponent = new DynamicRendererComponent(GridRendererComponent,this.section);
            this.rendererComponent.data = this.sectionData;
            if(this.currentComponent != undefined){
              this.currentComponent = this.rendererComponent.component;
              this.loadComponent(this.currentComponent);
            }else{
              this.currentComponent = this.rendererComponent.component;
            }
            //this.loadComponent(this.currentComponent);
            //console.log({Section:this.section});
            //console.log(this.rendererComponent);
            break;
          case "row":
          case "RendererType.ROW":
            this.section = new KwikstoreSection<Row>();
            this.section.heading = this.sectionData.heading;
            this.section.categoryId = this.categoryId;
            this.section.productId = this.productId;
            this.sectionData.isPreview = false;
            this.section.rowOptions = this.sectionData;
            this.section.sectionData = this.sectionData;
            this.rendererComponent = new DynamicRendererComponent(RowRendererComponent);
            this.rendererComponent.data = this.sectionData;
            if(this.currentComponent != undefined){
              this.currentComponent = this.rendererComponent.component;
              this.loadComponent(this.currentComponent);
            }else{
              this.currentComponent = this.rendererComponent.component;
            }
            break;
          case "banner":
          case "RendererType.BANNER":
            this.section = new KwikstoreSection<Banner>();
            this.section.heading = this.heading;
            this.section.categoryId = this.categoryId;
            this.section.productId = this.productId;
            this.section.bannerOptions = this.bannerOptions;
            this.section.sectionData = this.sectionData;
            this.rendererComponent = new DynamicRendererComponent(BannerRendererComponent);
            this.rendererComponent.data = this.sectionData;
            if(this.currentComponent != undefined){
              this.currentComponent = this.rendererComponent.component;
              this.loadComponent(this.currentComponent);
            }else{
              this.currentComponent = this.rendererComponent.component;
            }
            break;
          case "bloglist":
          case "RendererType.BLOGLIST":
            this.section = new KwikstoreSection<BlogList>({
              heading:this.heading,
            })
            this.section.sectionData = this.sectionData
            //this.section.blogListOptions = this.sectionData.blogListOptions;
            this.rendererComponent = new DynamicRendererComponent(BlogListRendererComponent,this.section);
            this.rendererComponent.data = this.section;
            console.log(this.section.blogListOptions)
            if(this.currentComponent != undefined){
              this.currentComponent = this.rendererComponent.component;
              this.loadComponent(this.currentComponent);
            }else{
              this.currentComponent = this.rendererComponent.component;
            }
            break;
          case "slider":
            console.log("Its a slider")
            this.section = new KwikstoreSection<Slider>();
            this.section.heading = this.sectionData.heading;
            this.section.sliderOptions = this.sectionData;
            this.rendererComponent = new DynamicRendererComponent(SliderRendererComponent);
            this.rendererComponent.data = this.section.sliderOptions;
            if(this.currentComponent != undefined){
              this.currentComponent = this.rendererComponent.component;
              this.loadComponent(this.currentComponent);
            }else{
              this.currentComponent = this.rendererComponent.component;
            }
            break;
          case "newsletter-sign-up":
            this.section = new KwikstoreSection<NewsLetterSignUp>();
            this.section.heading = this.sectionData.heading;
            this.section.newsLetterOptions = this.sectionData;
            this.rendererComponent = new DynamicRendererComponent(NewsletterSignupRendererComponent);
            this.rendererComponent.data = this.section.newsLetterOptions;
            if(this.currentComponent != undefined){
              this.currentComponent = this.rendererComponent.component;
              this.loadComponent(this.currentComponent);
            }else{
              this.currentComponent = this.rendererComponent.component;
            }
            break;
          case "store-features":
            this.section = new KwikstoreSection<StoreFeatures>()
            this.section.heading = this.sectionData.heading;
            this.rendererComponent = new DynamicRendererComponent(StoreFeatureRendererComponent);
            this.rendererComponent.data = this.section;
            if(this.currentComponent != undefined){
              this.currentComponent = this.rendererComponent.component;
              this.loadComponent(this.currentComponent);
            }else{
              this.currentComponent = this.rendererComponent.component;
            }
            break;
          case "rich-text":
          case "RendererType.RICH_TEXT":
            this.section = new KwikstoreSection<RichTextBlock>()
            this.section.heading = this.sectionData.heading;
            this.rendererComponent = new DynamicRendererComponent(RichTextRendererComponent);
            this.rendererComponent.data = this.sectionData;
            if(this.currentComponent != undefined){
              this.currentComponent = this.rendererComponent.component;
              this.loadComponent(this.currentComponent);
            }else{
              this.currentComponent = this.rendererComponent.component;
            }
            break;
          case "testimonials":
            this.section = new KwikstoreSection<Testimonials>()
            this.section.heading = this.sectionData.heading;
            this.rendererComponent = new DynamicRendererComponent(TestimonialRendererComponent);
            this.sectionData.isPreview = false;
            this.rendererComponent.data = this.sectionData;
            if(this.currentComponent != undefined){
              this.currentComponent = this.rendererComponent.component;
              this.loadComponent(this.currentComponent);
            }else{
              this.currentComponent = this.rendererComponent.component;
            }
            break;
          case "category":
          case "RendererType.CATEGORY":
            this.section = new KwikstoreSection<Category>();
            this.section.heading = this.sectionData.heading;
            this.rendererComponent = new DynamicRendererComponent(CategoryRendererComponent);
            this.sectionData.isPreview = false;
            this.rendererComponent.data = this.sectionData;
            if(this.currentComponent != undefined){
              this.currentComponent = this.rendererComponent.component;
              this.loadComponent(this.currentComponent);
            }else{
              this.currentComponent = this.rendererComponent.component;
            }
            break
          case "product":
          case "RendererType.PRODUCT":
            this.section = new KwikstoreSection<FeaturedProduct>();
            this.section.heading = this.sectionData.heading;
            this.rendererComponent = new DynamicRendererComponent(ProductRendererComponent);
            this.sectionData.isPreview = false;
            this.rendererComponent.data = this.sectionData;
            if(this.currentComponent != undefined){
              this.currentComponent = this.rendererComponent.component;
              this.loadComponent(this.currentComponent);
            }else{
              this.currentComponent = this.rendererComponent.component;
            }
            break
          case "cart":
          case "RendererType.CART":
            console.log("It's a cart")
            this.section = new KwikstoreSection<Cart>();
            this.section.heading = this.sectionData.heading;
            this.rendererComponent = new DynamicRendererComponent(CartRendererComponent);
            this.sectionData.isPreview = false;
            this.rendererComponent.data = this.sectionData;
            if(this.currentComponent != undefined){
              this.currentComponent = this.rendererComponent.component;
              this.loadComponent(this.currentComponent);
            }else{
              this.currentComponent = this.rendererComponent.component;
            }
            break
          case "blog":
          case "RendererType.BLOG":
            console.log("Rendering a blog");
              this.section = new KwikstoreSection<Blog>();
              this.section.heading = this.sectionData.heading;
              this.rendererComponent = new DynamicRendererComponent(BlogRendererComponent);
              this.sectionData.isPreview = false;
              this.rendererComponent.data = this.sectionData;
              if(this.currentComponent != undefined){
                this.currentComponent = this.rendererComponent.component;
                this.loadComponent(this.currentComponent);
              }else{
                this.currentComponent = this.rendererComponent.component;
              }
              break
            case "hero-image":
            case "RendererType.HEROIMAGE":
              this.section = new KwikstoreSection<Banner>();
              this.section.heading = this.heading;
              this.section.categoryId = this.categoryId;
              this.section.productId = this.productId;
              //this.section.bannerOptions = this.sectionData.bannerOptions;
              this.section.sectionData = this.sectionData;
              this.rendererComponent = new DynamicRendererComponent(HeroImageRendererComponent);
              this.rendererComponent.data = this.sectionData;
              if(this.currentComponent != undefined){
                this.currentComponent = this.rendererComponent.component;
                this.loadComponent(this.currentComponent);
              }else{
                this.currentComponent = this.rendererComponent.component;
              }
              break
          default:
            break;
        }
      }else{
        console.log("There's no fucking rendererType");
        console.log(this.sectionData)
      }
    }
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    this.loadComponent(this.currentComponent);
  }

  loadComponent(currentComponent){
    //console.log(currentComponent);
    //console.log({Heading:this.section.heading})
    const viewContainerRef = this.kwRenderSection.viewContainerRef;
    //console.log(viewContainerRef);
    viewContainerRef.clear();
    try {
      const componentRef = viewContainerRef.createComponent(currentComponent);
      (<RendererDataInterFace>componentRef.instance).data = this.rendererComponent.data;
      // componentRef.setInput("title",this.title);
      componentRef.changeDetectorRef.detectChanges();
      //this.cdref.detectChanges()
    } catch (error) {
      console.log(this.rendererType); 
      console.log(this.sectionData)     
    }
    
  }

}
